import React from 'react';
import moment from 'moment';
import { ICloudSourceRunStatus } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import CountUp from 'react-countup';
import { FixMe } from '@utils/types';
import Text from '@ui-library/table/components/text';
import TaskTitle from './statusTitle';
import StatusTable, { sourceStatusCommonColumns } from './StatusTable';

export interface CloudSourceRunProps {
  data?: ICloudSourceRunStatus[];
}
const CloudSourceRun = ({ data }: CloudSourceRunProps) => {
  let sourceRunColumns: FixMe = [
    {
      title: 'Table',
      dataIndex: 'taskId',
      key: 'taskId',
      width: '40%',
      render: (value: string, record: FixMe) => (
        <Text
          name={
            <TaskTitle
              title={value}
              error={record.error}
              done={
                !!(
                  record.finishedAt &&
                  (moment(record.finishedAt).isAfter(moment(record.startedAt)) ||
                    moment(record.finishedAt).isSame(moment(record.startedAt)))
                )
              }
            />
          }
        />
      ),
    },
    ...sourceStatusCommonColumns,
  ];
  const exportCountExists = data
    ?.filter((v) => !!v.taskRunId)
    .some((v: FixMe) => typeof v.exportedCount === 'number');
  if (exportCountExists) {
    sourceRunColumns = [
      ...sourceRunColumns,
      {
        title: 'Exported Count',
        dataIndex: 'exportedCount',
        render: (value: FixMe) =>
          typeof value === 'number' ? <CountUp preserveValue start={0} end={value} /> : '-',
      },
    ];
  }
  return <StatusTable columns={sourceRunColumns} data={data} />;
};

export default CloudSourceRun;
